const uimDefaultTokenSource = {
    name: 'uim',
    decorateRequest(request) {
        const requestOptions = request.requestOptions || {};
        requestOptions.headers = request.requestOptions.headers || {};
        requestOptions.headers.Authorization = request.token.startsWith('Bearer ') ? request.token : `Bearer ${request.token}`;
        return requestOptions;
    },
    validTokenForRequest(token) {
        try {
            // Get the expiration in seconds and convert to milliseconds
            // Assume token is in the format "Bearer tokenpart1.tokenpart2" where tokenpart2 is encoded "{ exp: n }"
            const expiration = parseInt(JSON.parse(atob(token.replace('Bearer ', '').split('.')[1])).exp, 10) * 1000;
            if (expiration - 60000 > Date.now()) {
                return true;
            }
            return false;
        } catch (ex) {
            return false;
        }
    },
    responseSignalsTokenRefresh() {
        return false;
    },
};
// eslint-disable-next-line import/prefer-default-export
export { uimDefaultTokenSource };



// WEBPACK FOOTER //
// ../loader-base/src/helpers/default-token-sources.js